import { CSSProperties } from 'react';
import {
  FaLocationDotLightSvgIcon,
  FaLocationPinLightSvgIcon,
} from '../../assets/icons/svgs';
import { UserLocation } from '../../redux/user/userSlice';
import { fontSize } from '../../theme/typography';
import {
  locationIconContainerStylesNotSelected,
  locationIconContainerStylesSelected,
  locationIconStyles,
} from './styles';
import { colors } from '../../theme/colors';

const LocationItemTypeIcon = ({
  location,
  isSelected,
  style,
  containerStyle,
}: {
  location: UserLocation;
  isSelected: boolean;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
}) => {
  const IconComponent = () => {
    return location?.isApproximateByDevice ? (
      <FaLocationDotLightSvgIcon
        size={fontSize['3xl']}
        style={{ ...locationIconStyles, ...style }}
        fill={isSelected ? colors.backgroundMedium : colors.textPrimary}
      />
    ) : (
      <FaLocationPinLightSvgIcon
        size={fontSize['3xl']}
        style={{ ...locationIconStyles, ...style }}
        fill={isSelected ? colors.backgroundMedium : colors.textPrimary}
      />
    );
  };

  return (
    <div
      style={{
        ...(isSelected
          ? locationIconContainerStylesSelected
          : locationIconContainerStylesNotSelected),
        ...containerStyle,
      }}
    >
      <IconComponent />
    </div>
  );
};

export default LocationItemTypeIcon;
